import React from "react";

const Blog = () => {
    return (
        <div id="fh5co-blog">
            <div className="container">
                <div className="row animate-box">
                    <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
                        <h2>Post on Medium</h2>
                        <p>Sharing my thoughts and experiences with the tech community through Medium articles.</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="fh5co-blog animate-box">
                            <a href="#" className="blog-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/blog-1.jpg)` }} aria-label="Blog post background image"></a>
                            <div className="blog-text">
                                <span className="posted_on">Feb. 15th 2023</span>
                                <h3><a href="#">Building Scalable Distributed Systems</a></h3>
                                <p>Exploring the challenges and solutions in building distributed systems that scale efficiently to handle millions of requests.</p>
                                <ul className="stuff">
                                    <li><i className="icon-heart2"></i>249</li>
                                    <li><i className="icon-eye2"></i>1,308</li>
                                    <li><a href="#">Read More<i className="icon-arrow-right22"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="fh5co-blog animate-box">
                            <a href="#" className="blog-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/blog-2.jpg)` }} aria-label="Blog post background image"></a>
                            <div className="blog-text">
                                <span className="posted_on">Aug. 23rd 2023</span>
                                <h3><a href="#">Machine Learning in Production</a></h3>
                                <p>A practical guide to deploying machine learning models in production environments with confidence and reliability.</p>
                                <ul className="stuff">
                                    <li><i className="icon-heart2"></i>149</li>
                                    <li><i className="icon-eye2"></i>1,203</li>
                                    <li><a href="#">Read More<i className="icon-arrow-right22"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="fh5co-blog animate-box">
                            <a href="#" className="blog-bg" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/portfolio-3.jpg)` }} aria-label="Blog post background image"></a>
                            <div className="blog-text">
                                <span className="posted_on">Jan. 5th 2024</span>
                                <h3><a href="#">Modern Frontend Development with React</a></h3>
                                <p>Exploring the latest React patterns and frameworks for building efficient and maintainable frontend applications.</p>
                                <ul className="stuff">
                                    <li><i className="icon-heart2"></i>188</li>
                                    <li><i className="icon-eye2"></i>978</li>
                                    <li><a href="#">Read More<i className="icon-arrow-right22"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog; 